export default __webpack_public_path__ + "static/media/jobListingProject.f33f4e3d.jpg";